function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isNonEmptyInput } from "../../infra/utils";
export const emptyExpiryError = 'Please enter a valid card expiry date';
export const emptyCvvError = 'Please enter a valid CVV';
export const emptyCardNumberError = 'Please enter a valid card number';
export const getInitialValueState = () => ({
  value: '',
  error: null,
  pristine: true,
  touched: false
});
export const getInitialStripeValue = function getInitialStripeValue() {
  let errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    touched: false,
    valid: false,
    errorMessage
  };
};
export function mapStripeErrorToMessage(error) {
  switch (error.code) {
    case 'card_declined':
      {
        switch (error.decline_code) {
          case 'invalid_account':
            return 'Credit card connection failed. The card, or account the card is connected to, is invalid. Contact your card issuer or connect a different payment method.';
          case 'transaction_not_allowed':
          case 'do_not_honor':
            return 'The card was declined. Contact your card issuer to find out why it was declined or connect a different payment method.';
          default:
            return null;
        }
      }
    case 'incorrect_cvc':
    case 'invalid_cvc':
      return "The card's security code is incorrect. Check the card's security code or use a different card.";
    case 'setup_intent_authentication_failure':
      return "The provided credit card has failed authentication. Please check the card's information or connect a different payment method.";
    case 'incorrect_number':
      return "The card number is incorrect. Check the card's number or use a different card.";
    default:
      return null;
  }
}
export const stripeStateReducer = (state, action) => {
  const {
    type,
    errorMessage = ''
  } = action;
  switch (type) {
    case 'error':
      return _objectSpread(_objectSpread({}, state), {}, {
        valid: false,
        errorMessage
      });
    case 'valid':
      return state.valid ? state : _objectSpread(_objectSpread({}, state), {}, {
        valid: true
      });
    case 'blur':
      return state.touched ? state : _objectSpread(_objectSpread({}, state), {}, {
        touched: true
      });
    default:
      return state;
  }
};
export function validateNameOnCard(value) {
  return isNonEmptyInput(value) ? '' : 'Please specify the name on the card.';
}
export function validateZipCode(value) {
  let minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  const trimmed = value.trim();
  let error = '';
  if (!isNonEmptyInput(trimmed)) {
    error = 'Please specify the ZIP code.';
  } else if (minLength > 0 && trimmed.length < minLength) {
    error = 'Please enter a valid 5-digit ZIP Code';
  }
  return error;
}